// extracted by mini-css-extract-plugin
export default {"title":"Attribute_title__zA7bV","item":"Attribute_item__W58ec"};